import Link from "next/link";

export default function City1({ item, currentPageAide, noImage = false }) {
  return (
    <>
      <Link
        href={`/${currentPageAide?.seo_permalink}/${item.slug_villes}`}
        className="block group"
      >
        <div className={`city2-content relative px-3 py-5 rounded-3xl ${noImage ? 'text-left' : 'text-center'}`}>

         {!noImage && <img
            sizes="100vw"
            src={`${item.cover_path ?? "/images/city/1.jpg"}`}
            alt={`${item.alt ?? "Vieillir à la maison image ville"}`}
            style={{ maxHeight: "116px", objectFit: "cover" }}
            className="rounded-full mx-auto w-full wow animate__animated animate__fadeInUp group-hover:scale-110 ease-in duration-300"
          />}
          <h4 className="mt-3 text-lg font-medium wow animate__animated animate__fadeInUp">
            {item.title}
          </h4>
        </div>
      </Link>
    </>
  );
}
